import React from 'react';
import { Button, Grid, Radio } from 'semantic-ui-react';
import aclService from 'shared/lib/acl';
import PropTypes from 'prop-types';
import { ACL } from 'shared/constants';

// Components
import { FilterInput, FilterSelect } from 'components/CandidatesArea/CandidatiFilterBar/filterBarElements';

// Services
import CollaboratoriService from '../../../shared/services/rpc/gestione-collaboratore';

const initialState = {
  areaManager: '--',
  tutor: '',
  seniorManager: '',
  active: true,
};

class FilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState,
      areaManagerLoading: true,
      areaManagerOptions: [],
    };
  }

  componentDidMount() {
    CollaboratoriService.getResponsabiliByAgenzia(null)
      .then((res) => {
        const options = res.listaResponsabiliArea.map((option) => ({
          key: option.id,
          value: option.id,
          text: option.nominativo,
        }));
        const optionsWithNull = [{ key: 'empty', value: '--', text: '--' }].concat(options);
        this.setState({ areaManagerOptions: optionsWithNull, areaManagerLoading: false });
      })
      .catch(() => this.setState({ areaManagerLoading: false }));
  }

  onResetClick = () => this.setState({ ...initialState });

  /** Apply filters */
  onFilter = () => {
    const params = {
      areaManager: this.state.areaManager !== '--' ? this.state.areaManager : null,
      tutor: this.state.tutor || null,
      seniorManager: this.state.seniorManager || null,
      active: this.state.active || null,
    };

    this.props.onFilter(params);
  };

  handleSearchEnter = (e) => {
    if (e.which === 13) {
      e.preventDefault();
      this.onFilter();
    }
  };

  render() {
    const { auth, addRecessoTutor, updateReteTutor } = this.props;

    // Define who can add a new recesso
    const canAddRecessoTutor = aclService.check(auth, ACL.CAN_CREATE_RECESSO);
    const canUpdateReteTutor = aclService.check(auth, ACL.CAN_CREATE_RECESSO);

    // Check if user is responsabileArea
    const isAreaManager = aclService.check(auth, ['responsabileArea']);

    return (
      <Grid onKeyDown={this.handleSearchEnter}>
        <Grid.Row>
          {!isAreaManager && (
            <Grid.Column width={4}>
              <FilterSelect
                label="Responsabile d'area"
                value={this.state.areaManager}
                options={this.state.areaManagerOptions}
                isLoading={this.state.areaManagerLoading}
                onChange={(_event, { value }) => this.setState({ areaManager: value })}
              />
            </Grid.Column>
          )}
          <Grid.Column width={4}>
            <FilterInput
              label="Tutor"
              value={this.state.tutor}
              onChange={(event) => this.setState({ tutor: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <FilterInput
              label="Senior Manager"
              value={this.state.seniorManager}
              onChange={(event) => this.setState({ seniorManager: event.target.value })}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <Radio
              checked={this.state.active}
              toggle
              label="Attive"
              onChange={(_e, data) => this.setState({ active: data.checked })}
              style={{ marginTop: 33 }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="right" verticalAlign="bottom" floated="right">
            <Button
              content="Reset"
              icon="repeat"
              labelPosition="left"
              onClick={this.onResetClick}
              style={{ marginRight: 15 }}
            />
            <Button
              icon="search"
              labelPosition="left"
              content="Cerca"
              positive
              onClick={this.onFilter}
              style={{ marginRight: 15 }}
            />
            {canAddRecessoTutor && (
              <Button icon="plus" labelPosition="left" primary content="Nuovo tutor" onClick={addRecessoTutor} />
            )}
            {canUpdateReteTutor && (
              <Button icon="plus" labelPosition="left" primary content="Modifica tutor" onClick={updateReteTutor} />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

FilterBar.propTypes = {
  // Manage auth
  auth: PropTypes.object,
  // Function to add new recesso tutor
  addRecessoTutor: PropTypes.func.isRequired,
  // Function to apply filter
  onFilter: PropTypes.func.isRequired,
  updateReteTutor: PropTypes.func.isRequired,
};

export default FilterBar;



// WEBPACK FOOTER //
// ./app/components/TutorList/FilterBar/index.js